export default "__VITE_ASSET__Ct_vOiRk__"